'use strict';

import '../../css/fields/mapField.scss';
import { markerDefault, markerSelected } from "./assets/mapMarkers";
import { selectMapElements } from "./elements/mapElements";
import 'leaflet';
import Base from '../Shared/Base';

export const EVENT_CLICK_MARKER = 'click_marker';

/**
 * @abstract
 */
export default class Map extends Base {

    constructor(bbox, distance, displaceMap) {
        super();

        // When there is no "where" searchterm. Use this to show NL.
        this.bboxNL = '50.7503658,53.744395,3.080161,7.2274985'.split(',');
        this.latNL = 52.15517;
        this.lngNL = 5.38721;
        this.displaceMap = displaceMap || false;
        this.distance = distance || 5;

        this.elements = selectMapElements();
        this.selectedMarker = null;
        this.map = null;

        // Init map no matter what
        this.draw();
    }

    draw(bbox, distance, displaceMap) {
        this.bbox = (typeof bbox === 'undefined' || bbox === '') ? this.bboxNL : bbox.split(',');
        this.lat = (typeof bbox === 'undefined' || bbox === '') ? this.latNL : (parseFloat(this.bbox[0]) + parseFloat(this.bbox[1])) / 2;
        this.lng = (typeof bbox === 'undefined' || bbox === '') ? this.lngNL : (parseFloat(this.bbox[2]) + parseFloat(this.bbox[3])) / 2;
        this.distance = distance || this.distance;
        this.displaceMap = displaceMap || this.displaceMap;
        if (this.map === null) {
            this.map = L.map('map', {zoomControl: true})
                .setView([this.lat, this.lng], 7);
            this.mapTiles(this.map);
            this.markerLayer = new L.LayerGroup();
            this.map.addLayer(this.markerLayer);
        }
        this.moveView(this.bbox, this.distance);
    }

    offsetBoundingBox() {
        this.bbox[0] = (parseFloat(this.bbox[0])+1.9).toString();
        this.bbox[1] = (parseFloat(this.bbox[1])-1.9).toString();
    }

    getBoundsDistance(bbox, distance) {
        const degrees = 0.0089982311916;
        return [
            [
                parseFloat(bbox[0]) - (degrees * distance),
                parseFloat(bbox[2]) - (degrees * distance)
            ],
            [
                parseFloat(bbox[1]) + (degrees * distance),
                parseFloat(bbox[3]) + (degrees * distance)
            ]
        ];

    }

    moveView(bbox, distance) {
        if (bbox.length < 4) {
            bbox = this.bboxNL;
        }
        const viewBounds = this.getBoundsDistance(bbox, distance || 5);
        const mapWidth = this.map.getSize().x;
        const paddingLeft = (this.displaceMap && mapWidth > 767) ? Math.round(mapWidth * 0.55) : 0;
        // leaflet bug TopLeft  [left, top] duh!
        this.map.flyToBounds(viewBounds, { paddingTopLeft: [paddingLeft, 0]});
        // view bbox
        // L.control.scale().addTo(this.map);
        // const polylinePoints = [
        //     viewBounds[0],
        //     [viewBounds[0][0], viewBounds[1][1]],
        //     viewBounds[1],
        //     [viewBounds[1][0], viewBounds[0][1]],
        //     viewBounds[0]
        // ];
        // L.polyline(polylinePoints).addTo(this.map);
    }

    moveViewLatLng(lat, lng) {
        const viewBounds = this.getBoundsDistance([lat, lat, lng, lng], 5);
        const mapWidth = this.map.getSize().x;
        const paddingLeft = (this.displaceMap && mapWidth > 767) ? Math.round(mapWidth * 0.55) : 0;
        this.map.flyToBounds(viewBounds, { paddingTopLeft: [paddingLeft, 0]});
    }

    mapTiles() {
        const url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        L.tileLayer(
            url,
            {
                attribution: `&copy; <a 
                            href="http://www.openstreetmap.org/copyright"
                            target="_blank" rel="noreferrer">OpenStreetMap</a>`
            }
        ).addTo(this.map);
    }

    mapMarkerIcon(markerStyle, markerSize) {
        return L.divIcon({
            html: markerStyle,
            iconSize: [markerSize, markerSize],
            iconAnchor: [markerSize/2, markerSize],
            className: '',
        });
    }

    addMarkers(markers) {
        this.markerLayer.clearLayers();
        markers.forEach(marker => {
            const m = L.marker(
                marker.position,
                {
                    icon: this.mapMarkerIcon(markerDefault.replace('*.*', marker.markerText), 32),
                    iconNumber: marker.markerNumber,
                    iconText: marker.markerText,
                    draggable: false,
                    autoPan: true
                }
            ).on('click', (e) => {
                const { options } = e.target.getIcon();
                const { iconText, iconNumber } = e.target.options;
                if (this.selectedMarker && iconNumber !== this.selectedMarker.options.iconNumber) {
                    const selectedIconText = this.selectedMarker.options.iconText;
                    this.selectedMarker.setIcon(this.mapMarkerIcon(markerDefault.replace('*.*', selectedIconText), 32));
                    this.selectedMarker = null;
                }
                if (options.iconSize[0] === 32) {
                   e.target.setIcon(this.mapMarkerIcon(markerSelected.replace('*.*', iconText), 40));
                   this.selectedMarker = e.target;
                } else {
                   e.target.setIcon(this.mapMarkerIcon(markerDefault.replace('*.*', iconText), 32));
                   this.selectedMarker = null;
                }
                this.dispatchEvent(new CustomEvent(
                    EVENT_CLICK_MARKER,
                    { detail: { number: iconNumber } }
                ));
            });
            this.markerLayer.addLayer(m);
        });
    }
}
